module.exports = __webpack_public_path__ + "6efc3823fdb9a2fe1d07e35836e087c5.pdf";